export default "__VITE_PUBLIC_ASSET__9c429b61__"